(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-tab-collections"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.tabs-wrapper li').forEach(tab => {
    tab.addEventListener('click', function () {
      const target = this.getAttribute('data-target');
      const parentUl = this.parentElement;
      parentUl.querySelectorAll('li').forEach(li => li.classList.remove('active'));
      this.classList.add('active');
      const wrapper = this.closest('.collection-list-wrapper');
      const slides = wrapper.querySelectorAll('slideshow-component');
      slides.forEach(slide => {
        if (slide.getAttribute('data-for') === target) {
          slide.style.display = '';
        } else {
          slide.style.display = 'none';
        }
      });

    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
